export function canEditIndicator<T>(
  readOnly: boolean | undefined,
  onClickIndicator?: (indicator: T) => void,
): boolean {
  return !readOnly && Boolean(onClickIndicator)
}
